export function developmentEmail(name: unknown) {
  const handle = String(name)
    .normalize("NFKD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, ".")
    .replace(/^\.+|\.+$/g, "");
  // Non-Latin names still produce a deterministic, non-empty handle.
  const fallback = [...String(name).trim()]
    .map((char) => char.codePointAt(0)!.toString(36))
    .join("");
  return `${(handle || `user.${fallback || "guest"}`).slice(0, 64)}@test.com`;
}
